import axios from "axios";
import { CreateUserDto, UserDto, UserRole, UserStatus } from "../models/User";
import baseUrl from "./baseUrl";

export default class UserApi {
	static resourceUrl = baseUrl + "/user-management";

	static async login(user: UserDto): Promise<any> {
		try {
			// Send a POST request
			const response = await axios({
				method: "POST",
				url: this.resourceUrl + "/login",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json",
				},
				data: user,
			});

			return response.data;
		} catch (error: any) {
			return error.response.data;
		}
	}

	static async getMe(data: { token: string | null }): Promise<any> {
		try {
			const { token } = data;

			// Send a POST request
			const response = await axios({
				method: "GET",
				url: this.resourceUrl + "/get-me",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json",
					Authorization: "Bearer " + token,
				},
			});

			return response.data;
		} catch (error: any) {
			return error.response.data;
		}
	}

	static async getUserById(data: {
		token: string | null;
		userId: string;
	}): Promise<any> {
		const { token } = data;

		// Send a POST request
		const response = await axios({
			method: "GET",
			url: this.resourceUrl + "/get-user/" + data.userId,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + token,
			},
		});

		return response.data;
	}

	static async userExistsByEmail(data: {
		token: string | null;
		email: string;
	}): Promise<{ exists: boolean }> {
		const { token, email } = data;

		const response = await axios({
			method: "GET",
			url: this.resourceUrl + "/user-exists?email=" + encodeURIComponent(email),
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + token,
			},
		});

		return response.data;
	}

	static async listUsers(data: {
		token: string | null;
		permissionaryId: string;
		query: string;
	}) {
		try {
			const { token } = data;

			// Send a POST request
			const response = await axios({
				method: "GET",
				url:
					this.resourceUrl +
					"/list-users?permissionaryId=" +
					data.permissionaryId +
					"&q=" +
					data.query,
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json",
					Authorization: "Bearer " + token,
				},
			});

			return response.data;
		} catch (error: any) {
			return error.response.data;
		}
	}

	static async addUser(data: { token: string; user: CreateUserDto }) {
		const { token, user } = data;

		// Send a POST request
		const response = await axios({
			method: "POST",
			url: this.resourceUrl + "/add-user",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + token,
			},
			data: user,
		});

		return response.data;
	}

	static async updateUser(data: {
		token: string;
		userId: string;
		user: {
			email: string;
			status: UserStatus;
			role: UserRole;
			permissionaryId: string;
		};
	}) {
		const { token, userId, user } = data;

		const response = await axios({
			method: "PUT",
			url: this.resourceUrl + "/update-user/" + userId,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + token,
			},
			data: user,
		});

		return response.data;
	}

	static async deleteUser(data: {
		token: string;
		userId: string;
		permissionaryId: string;
	}) {
		const { token, userId, permissionaryId } = data;

		// Send a POST request
		const response = await axios({
			method: "DELETE",
			url:
				this.resourceUrl +
				"/delete-user?id=" +
				userId +
				"&permissionaryId=" +
				permissionaryId,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + token,
			},
		});

		return response.data;
	}
}
